/** Words many screens share, and the units' short forms. */
export const common = {
  'common.cancel': 'გაუქმება',
  'common.confirm': 'დადასტურება',
  'common.close': 'დახურვა',
  'common.delete': 'წაშლა',
  'common.print': 'ბეჭდვა',
  'common.all': 'ყველა',
  'common.add': 'დამატება',
  'common.return': 'დაბრუნება',
  'common.on': 'ჩართულია',
  'common.off': 'გამორთულია',
  'common.processing': 'მიმდინარეობს...',
  'common.popupBlocked': 'ბრაუზერმა ფანჯარა დაბლოკა — დაუშვი pop-up',
  'common.outOfStock': 'ამოიწურა',
  'common.language': 'ენა',
  'common.notFound': 'ვერ მოიძებნა',
  'common.product': 'პროდუქტი',
  'common.edit': 'რედაქტირება',
  'common.save': 'შენახვა',
  'common.note': 'შენიშვნა',
  'common.optional': 'არასავალდებულო',
  'common.loading': 'იტვირთება…',
  'common.back': 'უკან',

  // The interface's short forms. The printed receipt keeps UNIT_SHORT
  // (lib/mock-data) — a test holds these equal to it in Georgian.
  'unit.piece': 'ც',
  'unit.kg': 'კგ',
  'unit.m': 'მ',
  'unit.l': 'ლ',
  'unit.pieceLong': 'ცალი',

  'time.yesterday': 'გუშინ',
  'time.daysAgo': '{n} დღის წინ',

  // The drawer's reasons and where money went at close. The Z-report and the
  // morning mail keep their own Georgian copies (lib/mock-data, lib/drawer-
  // float) — a test holds these equal to them.
  'reason.owner': 'მფლობელმა წაიღო',
  'reason.expense': 'ხარჯი',
  'reason.bank': 'ბანკში შეტანა',
  'reason.change': 'ხურდის დამატება',
  'reason.other': 'სხვა',
  'cashdoc.supplier_return': 'მომწოდებლის დაბრუნება',
  'cashdoc.purchase': 'მიღება სალაროდან',
  'takeout.owner': 'მფლობელს',
  'takeout.bank': 'ბანკში',
  'takeout.other': 'სხვა',

  'expenseCat.rent': 'ქირა',
  'expenseCat.salary': 'ხელფასი',
  'expenseCat.utilities': 'კომუნალური',
  'expenseCat.transport': 'ტრანსპორტი',
  'expenseCat.marketing': 'რეკლამა',
  'expenseCat.bank': 'საბანკო მომსახურება',
  'expenseCat.taxes': 'გადასახადები',
  'expenseCat.writeoff': 'ჩამოწერილი საქონელი',
  'expenseCat.other': 'სხვა',
} as const
